<template>
    <section class="bg-[#f9f9f9] py-20 px-4">
      <div class="max-w-6xl mx-auto text-center mb-16">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
          Ei, você precisa saber disso...
        </h2>
        <p class="text-sm text-gray-500">
          veja algumas vantagens que você encontra somente aqui
        </p>
      </div>
  
      <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          v-for="(item, index) in vantagens"
          :key="index"
          class="bg-white rounded-2xl shadow p-6 text-center"
        >
          <div class="flex justify-center mb-4">
            <img :src="item.icone" :alt="item.titulo" class="w-40 h-40" />
          </div>
          <h3 class="font-bold text-lg mb-2">{{ item.titulo }}</h3>
          <p class="text-sm text-gray-600">{{ item.descricao }}</p>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const vantagens = [
    {
      titulo: 'Deploy Automatizado via Git',
      descricao:
        'Deploy automatizado de seus aplicativos Node.js com GIT privado simples e rápido.',
      icone: '/icones-vantagens/git.svg'
    },
    {
      titulo: 'Integrator Force https://',
      descricao:
        'Redireciona o acesso http de seu dominio para https facilmente com apenas um click.',
      icone: '/icones-vantagens/force.svg'
    },
    {
      titulo: 'Integrator Node.js',
      descricao:
        'Painel exclusivo para deploy de aplicações Node.js independentes, qualquer versão, com PM2 e visualização de logs.',
      icone: '/icones-vantagens/node.svg'
    },
    {
      titulo: 'Suporte especializado',
      descricao:
        'Suporte especializado com programadores que entendem a sua solicitação',
      icone: '/icones-vantagens/suporte.svg'
    },
    {
      titulo: 'Scan de Arquivos',
      descricao:
        'Disponibilizamos ferramentas para scanner arquivos com problemas de código maliciosos, vulnerabilidade ou falha de segurança.',
      icone: '/icones-vantagens/virus.svg'
    },
    {
      titulo: 'Proteção DDoS',
      descricao:
        'Nossa infraestrutura é protegida no nível da rede. Você pode ter certeza de que suas instâncias serão resilientes aos ataques mais populares.',
      icone: '/icones-vantagens/ddos.svg'
    }
  ]
  </script>
  